// import { ButtonBase, useMediaQuery, useTheme } from '@material-ui/core';
import { ButtonBase } from '@material-ui/core';
import React from 'react';

import { lightTheme } from '../lib/theme';
const { button } = lightTheme.components;

export const ModalButton = ({
  onClick,
  label,
  style,
  title,
  disabled = false,
}: {
  onClick: () => void;
  label: React.ReactNode;
  style?: React.CSSProperties;
  title?: string;
  disabled?: boolean;
}) => {
  // const theme = useTheme();
  // const isSmallScreen = useMediaQuery(theme.breakpoints.only('xs'));

  const palate = disabled ? button.disabled : button.outline.neutral;

  return (
    <ButtonBase
      className="design-v3-font"
      onClick={onClick}
      style={{
        padding: '0 24px',
        height: 60,
        fontSize: 16,
        lineHeight: 1,
        // fontWeight: 500,
        color: palate.label,
        // background: palate.bg,
        border: `1px solid ${palate.bg}`,
        borderRadius: 10,
        cursor: disabled ? 'default' : 'pointer',
        // width: isSmallScreen ? '100%' : 'auto',
        ...style,
      }}
      title={title}
      disabled={disabled}
    >
      {label}
    </ButtonBase>
  );
};
